import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import InterSectionObserver from '../../../common/components/intersection/InterSectionObserver';
import filterImg from "../../assets/image/filter-icon.svg"
import {Moments} from "@common/utils/date/moments";
import Tab from "../component/Tab";
import useFetch from "@common/hooks/fetch/useFetch";
import {getJournalList, getJournalSectionList} from "@common/services/restapi/journal";
import LargeCardVertical from "../set/LargeCardVertical";
import FilterModal from "../component/FilterModal";
import Page from '../../../common/enums/Page.enums'
import {Link} from "react-router-dom";
import {LazyLoadImage} from "react-lazy-load-image-component";
import ViewIcon from "../../assets/image/icon_eye.svg";
import Split from "../../assets/image/split.svg";
import {isEmpty} from '@common/utils/common-utils'
import {convertPath} from "@common/utils/path/linkPath";

const filterList = [
  {
    ko: 'INNOCEAN Worldwide',
    data: 'filter01',
  },
  {
    ko: 'SK플래닛 M&C부문',
    data: 'filter02',
  },
  {
    ko: 'KAA저널',
    data: 'filter03',
  },
  {
    ko: '대홍 커뮤니케이션즈',
    data: 'filter04',
  },
  {
    ko: 'CHEIL WORLDWIDE',
    data: 'filter05',
  },
  {
    ko: '오리콤 브랜드 저널',
    data: 'filter06',
  },
  {
    ko: '한국ABC저널',
    data: 'filter07',
  },
  {
    ko: 'the AD',
    data: 'filter08',
  },
  {
    ko: '펜타브리드',
    data: 'filter09',
  },
  {
    ko: '서비스플랜코리아',
    data: 'filter10',
  },
  {
    ko: 'BIG BAND',
    data: 'filter11',
  },
  {
    ko: '메조미디어',
    data: 'filter12',
  },
  {
    ko: '신문광고저널',
    data: 'filter13',
  },
  {
    ko: '한국광고업협회보',
    data: 'filter14',
  },
  {
    ko: '광고계동향',
    data: 'filter15',
  },
  {
    ko: 'HS Ad',
    data: 'filter16',
  },
  {
    ko: '소비자',
    data: 'filter17',
  },
  {
    ko: '나스미디어',
    data: 'filter18',
  },
  {
    ko: '광고계동향 분석보고서',
    data: 'filter19',
  },
  {
    ko: '한국옥외광고센터',
    data: 'filter20',
  },
  {
    ko: '인크로스',
    data: 'filter21',
  },
  {
    ko: '제일기획 매거진',
    data: 'filter22',
  },
]

function MagazineList() {

  let urlSearchParams = new URLSearchParams(location.search);
  const sectionUkey = urlSearchParams.get("sectionUkey");
  const [magazineData, setMagazineData] = useState([]);
  const [page, setPage] = useState(Page.page.defaultPage);
  const [filterModal, setFilterModal] = useState(false);

  const detailSearch = useMemo(() => {
    return {
      sectionUkey: sectionUkey,
      pageNumber: page,
      pageSize: Page.size.defaultSize,
      sourceUkey: "",
      sortField1: "wdate",
      sortOption1: "DESC",
      dateType: ""
    }
  }, [page]);

  const [isEnd, setIsEnd] = useState(false)

  const filter = useMemo(() => {
    return {
      sectionUkey: sectionUkey,
      pageNumber: page,
      pageSize: 10,
      sourceUkey: "",
      sortField1: "wdate",
      sortOption1: "DESC",
      dateType: ""
    }
  }, [page]);

  const {data: journalSectionList} = useFetch(() => getJournalSectionList(), [], []);
  const {data: journalList, loading: dataLoading} = useFetch(() => getJournalList(detailSearch), [detailSearch], {});

  useEffect(() => {
    if (journalList && journalList.articleList) {
      setMagazineData(magazineData.concat(journalList.articleList));
    }
  }, [journalList]);

  const handleObserver = useCallback(() => {
    setPage(page + 1);
  }, [page]);

  const handleTabMove = useCallback((selectSectionUkey) => {
    window.location.replace(convertPath("/magazine?sectionUkey=" + selectSectionUkey));
  }, []);

  const sectionList = useMemo(() => {
    if (journalSectionList.length > 0) {
      const sectionLitArr = [{eng: '전체', ko: '전체', sectionUkey: ''}];
      journalSectionList.forEach((section) => {
        sectionLitArr.push({eng: section.name, ko: section.name, sectionUkey: section.ukey});
      });
      return sectionLitArr;
    }
    return [];
  }, [journalSectionList]);

  const selectSectionText = useMemo(() => {
    if (journalSectionList.length > 0) {
      if (sectionUkey) {
        const findSection = journalSectionList.find(section => section.ukey === parseInt(sectionUkey, 10));
        if (findSection) {
          return findSection.name;
        }
      } else {
        return '전체';
      }
    }
    return '전체';
  }, [journalSectionList]);


  return (
    <>
      <div className="common-header--top">
        <h3 className="header-title">매거진</h3>
        {/*<div className="filter" onClick={() => setFilterModal(true)}>
          <img src={filterImg} alt=""/>
        </div>*/}
      </div>

      <section className="common-body--list">
        {
          sectionList.length > 0 && !isEmpty(selectSectionText) &&
          <Tab
            additionalClassName="mt-4 mb-4"
            setSelectedThing={() => {
            }}
            selectedThing={selectSectionText}
            setSectionUkey={handleTabMove}
            thingsList={sectionList}
          />
        }
        <div className="magazine-list">
          <>
            {magazineData && magazineData.map((eachData, index) => {
                return (
                  <div className={`ad-box large-vertical`} key={`ad-${index}`}>
                    <Link to={`/magazine/${eachData.ukey}`}>
                      <div className="thumbnail-card-wrapper">
                        {
                          eachData.thumbnail.endsWith('.jpg') || eachData.thumbnail.endsWith('.png') ?
                            <LazyLoadImage className="thumbnail-card small-video" src={`${eachData.thumbnail.replace('/l/', '/m/').replace("http:", "https:")}`}/>
                            :
                            <LazyLoadImage className="thumbnail-card small-video"/>
                        }
                      </div>
                      <div className="ad-info">
                        <h4 className="title">{eachData.title} </h4>
                        <div className="row-box">
                          <h5 className="brand">
                            {
                              eachData.brand === "" ? "Ad Magazine" : eachData.brand
                            }
                          </h5>
                          <>
                            {
                              eachData.rcount !== 0 &&
                              <>
                                <div className="view-count">
                                  <LazyLoadImage src={ViewIcon} alt=""/>
                                  <span>{eachData.rcount}</span>
                                </div>
                                <LazyLoadImage src={Split} alt=""/>
                              </>
                            }
                            <div className="created-date">{Moments.Format(eachData.wdate, 'yyyy.MM.DD')}</div>
                          </>
                        </div>
                      </div>
                    </Link>
                  </div>
                )
              }
            )}
          </>
        </div>
        <InterSectionObserver dataLoading={dataLoading} onHandleObserver={handleObserver}/>
      </section>

      <FilterModal
        className="magazine"
        show={filterModal}
        heading="필터"
        btn100Text="적용"
        filterList={filterList}
        onClick={() => setFilterModal(false)}
      />
    </>
  )
}

export default MagazineList;
